import { render, staticRenderFns } from "./font-size.vue?vue&type=template&id=72ff8dfd&"
import script from "./font-size.vue?vue&type=script&lang=js&"
export * from "./font-size.vue?vue&type=script&lang=js&"
import style0 from "./font-size.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('72ff8dfd', component.options)
    } else {
      api.reload('72ff8dfd', component.options)
    }
    module.hot.accept("./font-size.vue?vue&type=template&id=72ff8dfd&", function () {
      api.rerender('72ff8dfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/font-size.vue"
export default component.exports